
import React, { useState } from 'react';

const DirectionsSection: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'johannesburg' | 'pretoria'>('johannesburg');

  const directions = {
    johannesburg: [
      'Take the N1 North towards Pretoria',
      'Head toward Midrand and Randjesfontein Country Estate',
      'Follow navigation to Riboville Road',
      'Enter Randjesfontein Country Estate',
      'Proceed to No 6 Riboville Road'
    ],
    pretoria: [
      'Take the N1 South towards Johannesburg',
      'Head toward Midrand and Randjesfontein Country Estate',
      'Follow navigation to Riboville Road',
      'Enter Randjesfontein Country Estate',
      'Proceed to No 6 Riboville Road'
    ]
  };

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Directions</h2>
          <p className="text-lg text-gray-600">
            Easy access from both Johannesburg and Pretoria
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          {/* Tab Navigation */}
          <div className="flex justify-center mb-8">
            <div className="bg-white rounded-lg p-1 shadow-md">
              <button
                onClick={() => setActiveTab('johannesburg')}
                className={`px-6 py-3 rounded-md font-medium transition-colors whitespace-nowrap ${
                  activeTab === 'johannesburg'
                    ? 'bg-green-600 text-white'
                    : 'text-gray-600 hover:text-gray-900'
                }`}
              >
                From Johannesburg
              </button>
              <button
                onClick={() => setActiveTab('pretoria')}
                className={`px-6 py-3 rounded-md font-medium transition-colors whitespace-nowrap ${
                  activeTab === 'pretoria'
                    ? 'bg-green-600 text-white'
                    : 'text-gray-600 hover:text-gray-900'
                }`}
              >
                From Pretoria
              </button>
            </div>
          </div>

          {/* Directions Content */}
          <div className="bg-white rounded-lg shadow-lg p-8">
            <h3 className="text-xl font-semibold text-gray-900 mb-6 flex items-center">
              <i className="ri-route-line text-green-600 mr-3"></i>
              {activeTab === 'johannesburg' ? 'From Johannesburg' : 'From Pretoria'}
            </h3>
            
            <div className="space-y-4">
              {directions[activeTab].map((step, index) => (
                <div key={index} className="flex items-start space-x-4">
                  <div className="w-8 h-8 bg-green-600 text-white rounded-full flex items-center justify-center font-semibold text-sm flex-shrink-0">
                    {index + 1}
                  </div>
                  <p className="text-gray-700 pt-1">{step}</p>
                </div>
              ))}
            </div>

            <div className="mt-8 pt-8 border-t border-gray-200">
              <h4 className="font-semibold text-gray-900 mb-4 flex items-center">
                <i className="ri-parking-line text-green-600 mr-3"></i>
                Parking Information
              </h4>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <h5 className="font-medium text-gray-900 mb-2">Visitor Parking</h5>
                  <ul className="text-gray-600 space-y-1">
                    <li>• Free parking available</li>
                    <li>• Covered parking bays</li>
                    <li>• Disabled parking spaces</li>
                  </ul>
                </div>
                <div>
                  <h5 className="font-medium text-gray-900 mb-2">Security</h5>
                  <ul className="text-gray-600 space-y-1">
                    <li>• 24/7 security on site</li>
                    <li>• Visitor registration required</li>
                    <li>• CCTV monitoring</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DirectionsSection;
